<!-- 组件说明 -->
<template>
  <div class="buy-num">
    <div class="line-one">
      <span>{{ toYear }}年老带新认购总数</span>
      <span class="sale-num">
        {{ parseInt(statisticsData.ldxSubscribeTotal) }}
      </span>
      <span>套</span>
    </div>
    <div class="line-two">
      <span>签约总套数</span>
      <span class="sale-num">
        {{ parseInt(statisticsData.ldxSigningTotal) }}
      </span>
      <span>套</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["statisticsData", "toYear"],
  watch: {
    toYear(v) {
      this.toYear = v;
    },
  },
};
</script>

<style lang="scss" scoped>
.buy-num {
  height: 140px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #195541;
  text-align: center;
  padding-top: 20px;

  line-height: 40px;
  .line-two {
    margin-top: 16px;
  }
  .sale-num {
    font-size: 32px;
  }
}
</style>
